import React from "react";
import { useHistory } from "react-router-dom";
import RootSearchForUser from "container/searchForUser/RootSearchForUser";
import RootSearchForGuest from "container/searchForGuest/RootSearchForGuest";
import { withStore } from "store/storeHandler";
import { getEssentialUrl } from "lib/urlQueryParser";
import GaHelper from "lib/gaHelper";

function RootSearch(props) {
  const { searchQry, hasLoggedIn } = props;

  const history = useHistory();

  const handleLoginRecommendationBtnClick = loc => () => {
    history.push(getEssentialUrl({ type: "account", allowRefParam: true })());

    GaHelper.setGAClickEvent({ type: "logInRecommendationBtn", loc });
  };

  if (hasLoggedIn) return <RootSearchForUser searchQry={searchQry} />;
  else
    return (
      <RootSearchForGuest
        onLoginRecommendationBtnClick={handleLoginRecommendationBtnClick}
      />
    );
}

export default withStore({
  stateMap: { myAccount: ["hasLoggedIn"] }
})(RootSearch);
